import { render, staticRenderFns } from "./PropertySlider.vue?vue&type=template&id=64916db0&scoped=true&"
import script from "./PropertySlider.vue?vue&type=script&lang=js&"
export * from "./PropertySlider.vue?vue&type=script&lang=js&"
import style0 from "./PropertySlider.vue?vue&type=style&index=0&id=64916db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64916db0",
  null
  
)

export default component.exports